module.exports = __webpack_public_path__ + "img/sample-info-icon.06438c6f.svg";